"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flowchart = exports.code = exports.brand = exports.icon = exports.button = exports.bg = exports.text = exports.border = void 0;

var primitives_1 = require("./primitives");

exports.border = {
  primary: {
    base: primitives_1.silver[500],
    dark: primitives_1.navy[200]
  },
  secondary: {
    base: primitives_1.silver[400],
    dark: primitives_1.navy[300]
  },
  hover: {
    base: primitives_1.gray[300],
    dark: primitives_1.gray[300]
  },
  success: {
    base: primitives_1.green[400],
    dark: primitives_1.green[300]
  },
  error: {
    base: primitives_1.red[400],
    dark: primitives_1.red[300]
  },
  warning: {
    base: primitives_1.orange[500],
    dark: primitives_1.orange[200]
  },
  neutral: {
    base: primitives_1.gray[400],
    dark: primitives_1.gray[200]
  },
  info: {
    base: primitives_1.blue[400],
    dark: primitives_1.blue[200]
  },
  beta: {
    base: primitives_1.purple[400],
    dark: primitives_1.purple[200]
  },
  focused: {
    base: primitives_1.blue[200],
    dark: primitives_1.blue[200]
  },
  disabled: {
    base: primitives_1.silver[400],
    dark: primitives_1.silver[200]
  }
};
var heading = {
  base: primitives_1.navy[500],
  dark: primitives_1.silver[200]
};
exports.text = {
  primary: {
    base: primitives_1.gray[600],
    dark: primitives_1.silver[500]
  },
  secondary: {
    base: primitives_1.gray[500],
    dark: primitives_1.gray[200]
  },
  placeholder: {
    base: primitives_1.gray[300],
    dark: primitives_1.navy[100]
  },
  heading: heading,

  /**
   * @deprecated Use `heading` instead.
   */
  header: heading,
  link: {
    base: primitives_1.blue[400],
    dark: primitives_1.blue[200]
  },
  success: {
    base: primitives_1.green[500],
    dark: primitives_1.green[200]
  },
  error: {
    base: primitives_1.red[500],
    dark: primitives_1.red[100]
  },
  warning: {
    base: primitives_1.orange[600],
    dark: primitives_1.orange[100]
  },
  neutral: {
    base: primitives_1.gray[600],
    dark: primitives_1.gray[100]
  },
  info: {
    base: primitives_1.blue[500],
    dark: primitives_1.blue[100]
  },
  beta: {
    base: primitives_1.purple[500],
    dark: primitives_1.purple[100]
  },
  disabled: {
    base: primitives_1.gray[200],
    dark: primitives_1.navy[300]
  },
  inverted: {
    base: primitives_1.silver[100],
    dark: primitives_1.navy[500]
  },
  white: {
    base: primitives_1.silver[100],
    dark: primitives_1.silver[100]
  }
};
exports.bg = {
  primary: {
    base: primitives_1.silver[100],
    dark: primitives_1.black[100]
  },
  secondary: {
    base: primitives_1.silver[300],
    dark: primitives_1.black[200]
  },
  success: {
    base: primitives_1.green[100],
    dark: primitives_1.green[400]
  },
  error: {
    base: primitives_1.red[100],
    dark: primitives_1.red[400]
  },
  errorSelected: {
    base: primitives_1.red[200],
    dark: primitives_1.red[500]
  },
  warning: {
    base: primitives_1.orange[100],
    dark: primitives_1.orange[400]
  },
  warningSelected: {
    base: primitives_1.orange[200],
    dark: primitives_1.orange[500]
  },
  neutral: {
    base: primitives_1.silver[400],
    dark: primitives_1.navy[400]
  },
  info: {
    base: primitives_1.blue[100],
    dark: primitives_1.blue[400]
  },
  beta: {
    base: primitives_1.purple[100],
    dark: primitives_1.purple[300]
  },
  input: {
    base: primitives_1.silver[100],
    dark: primitives_1.navy[400]
  },
  disabled: {
    base: primitives_1.silver[400],
    dark: primitives_1.navy[400]
  },
  white: {
    base: primitives_1.silver[100],
    dark: primitives_1.silver[100]
  },
  selected: {
    base: primitives_1.navy[400],
    dark: primitives_1.navy[200]
  },
  unselected: {
    base: primitives_1.gray[500],
    dark: primitives_1.gray[400]
  }
};
exports.button = {
  primary: {
    base: primitives_1.navy[400],
    dark: primitives_1.navy[200]
  },
  primaryHover: {
    base: primitives_1.navy[500],
    dark: primitives_1.navy[300]
  },
  destructive: {
    base: primitives_1.red[400],
    dark: primitives_1.red[400]
  },
  destructiveHover: {
    base: primitives_1.red[500],
    dark: primitives_1.red[500]
  },
  secondary: {
    base: primitives_1.silver[100],
    dark: primitives_1.black[100]
  },
  secondaryHover: {
    base: primitives_1.silver[300],
    dark: primitives_1.black[300]
  },
  disabled: {
    base: primitives_1.silver[400],
    dark: primitives_1.black[200]
  }
};
exports.icon = {
  primary: exports.text.primary,
  secondary: {
    base: primitives_1.gray[500],
    dark: primitives_1.gray[400]
  },
  success: {
    base: primitives_1.green[400],
    dark: primitives_1.green[200]
  },
  error: {
    base: primitives_1.red[400],
    dark: primitives_1.red[200]
  },
  warning: {
    base: primitives_1.orange[500],
    dark: primitives_1.orange[200]
  },
  info: {
    base: primitives_1.blue[400],
    dark: primitives_1.blue[200]
  },
  beta: {
    base: primitives_1.purple[400],
    dark: primitives_1.purple[200]
  },
  disabled: {
    base: primitives_1.gray[200],
    dark: primitives_1.navy[300]
  },
  inverted: {
    base: primitives_1.silver[100],
    dark: primitives_1.navy[500]
  },
  white: {
    base: primitives_1.silver[100],
    dark: primitives_1.silver[100]
  }
};
var nebula = {
  base: primitives_1.navy[500],
  dark: primitives_1.navy[100]
};
var satellite = {
  base: primitives_1.gray[200],
  dark: primitives_1.gray[400]
};
var regolith = {
  base: primitives_1.beige[500],
  dark: primitives_1.beige[400]
};
var horizon = {
  base: primitives_1.orange[400],
  dark: primitives_1.orange[300]
};
exports.brand = {
  nebula: nebula,
  primary: nebula,
  satellite: satellite,
  secondary: satellite,
  regolith: regolith,
  tertiary: regolith,
  horizon: horizon,
  accent: horizon
};
exports.code = {
  a: {
    base: primitives_1.gray[500],
    dark: primitives_1.gray[200]
  },
  b: {
    base: primitives_1.blue[400],
    dark: primitives_1.blue[200]
  },
  c: {
    base: primitives_1.purple[300],
    dark: primitives_1.purple[200]
  },
  d: {
    base: primitives_1.green[500],
    dark: primitives_1.green[300]
  },
  e: {
    base: primitives_1.yellow[500],
    dark: primitives_1.yellow[300]
  },
  f: {
    base: primitives_1.navy[300],
    dark: primitives_1.navy[100]
  },
  g: {
    base: primitives_1.orange[500],
    dark: primitives_1.orange[200]
  }
};
exports.flowchart = {
  text: exports.text.primary,
  a: exports.code.e,
  b: exports.code.d,
  c: {
    base: primitives_1.orange[400],
    dark: primitives_1.orange[300]
  },
  e: {
    base: primitives_1.blue[300],
    dark: primitives_1.blue[200]
  }
};